export const buttonsTranslationRU = {
  buttons: {
    "save": "Сохранить",
    "cancel": "Отмена",
    "new": "Cоздать",
    "close": "Закрыть",
    "exit": "Выход",
    "back": "Назад",
  }
}